import { css, keyframes } from "@emotion/react";
import React from "react";

import { Box, Typography } from "@mui/material";
import { appColor } from "@/styles/constants/colors";

const InitialScreenContainer: React.FC = () => {
  return (
    <Box css={initialStyled}>
      <Box css={contentStyled}>
        <img src="/images/service-main-logo.png" alt="HINOME" css={logoImage} />

        <Box css={spinnerContainer}>
          <Box css={spinner} />
        </Box>

        <Box css={textContainer}>
          <Typography variant="body2" sx={{ color: appColor.text.secondary, letterSpacing: 1, mb: 1.5 }}>
            読み込み中...
          </Typography>
          <Typography variant="body2" sx={{ color: appColor.text.Negative, lineHeight: 1.8 }}>
            Instagramの分析データを、
            <br />
            次の成果につなげよう。
          </Typography>
        </Box>
      </Box>

      {/* モバイル用CSS波グラデーション */}
      <Box css={waveBottom} />
    </Box>
  );
};

export default InitialScreenContainer;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

const initialStyled = css`
  z-index: -10;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  /* デスクトップ: blob SVG背景 */
  background-color: #fafafa;
  background-image: url("/images/blob-scene-haikei.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  /* モバイル: SVGを非表示にしてシンプルな背景に */
  @media (max-width: 600px) {
    background-image: none;
    background: linear-gradient(180deg, #fafafa 0%, #f0f7f4 60%, #dceee7 100%);
  }
`;

const contentStyled = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 16px;
  animation: ${fadeIn} 0.5s ease-out;
  position: relative;
  z-index: 1;
`;

const logoImage = css`
  max-width: 200px;
  width: 100%;
  height: auto;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const spinnerContainer = css`
  display: flex;
  justify-content: center;
`;

const spinner = css`
  width: 28px;
  height: 28px;
  border: 3px solid rgba(64, 150, 123, 0.15);
  border-top-color: #40967b;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const textContainer = css`
  text-align: center;
  margin-top: 8px;
`;

const waveBottom = css`
  display: none;

  @media (max-width: 600px) {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(
      180deg,
      transparent 0%,
      rgba(64, 150, 123, 0.03) 30%,
      rgba(64, 150, 123, 0.08) 100%
    );

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: -50%;
      width: 200%;
      height: 120px;
      border-radius: 50% 50% 0 0;
      background: linear-gradient(135deg, rgba(64, 150, 123, 0.06) 0%, rgba(45, 107, 90, 0.1) 100%);
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -20px;
      left: -30%;
      width: 160%;
      height: 100px;
      border-radius: 50% 50% 0 0;
      background: linear-gradient(135deg, rgba(64, 150, 123, 0.04) 0%, rgba(64, 150, 123, 0.08) 100%);
    }
  }
`;
